import { Link } from 'react-router-dom';
import { useState } from 'react';
import { animeList, categories, faqData } from '@/mocks/anime';

function HeroSection() {
  return (
    <section className="relative w-full h-[480px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Beautiful%20anime%20style%20scenery%20with%20cherry%20blossom%20trees%20in%20full%20bloom%2C%20soft%20pink%20petals%20floating%20in%20air%2C%20warm%20sunlight%20filtering%20through%20branches%2C%20dreamy%20atmosphere%2C%20Japanese%20spring%20landscape%2C%20gentle%20watercolor%20texture%2C%20ethereal%20and%20romantic%20mood&width=1600&height=900&seq=hero-bg-sakura&orientation=landscape"
          alt="樱花动漫 - 免费动漫在线观看"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      </div>
      <div className="relative z-10 text-center px-4 max-w-3xl mx-auto">
        <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center mx-auto mb-4">
          <i className="ri-flower-line text-primary-400 text-4xl md:text-5xl"></i>
        </div>
        <h1 className="font-heading text-3xl md:text-5xl text-background-50 mb-4 leading-tight">
          樱花动漫网
        </h1>
        <p className="text-base md:text-lg text-background-100/90 mb-8 leading-relaxed max-w-xl mx-auto">
          海量免费动漫全集在线观看 &middot; 热门完结动漫一网打尽 &middot; 每日更新追番无忧
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/rexue"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-8 py-3 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
          >
            <i className="ri-fire-line"></i>
            开始追番
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 px-8 py-3 rounded-full font-medium text-sm hover:bg-background-50/30 transition-all duration-200 whitespace-nowrap"
          >
            <i className="ri-information-line"></i>
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}

function HotAnimeSection() {
  const hotAnime = animeList.filter(a => a.isHot).slice(0, 6);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              <i className="ri-fire-line text-accent-500 mr-2"></i>
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">大家都在看的爆款动漫</p>
          </div>
          <Link to="/category/rexue" className="text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap">
            查看更多 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotAnime.map((anime) => (
            <Link
              key={anime.id}
              to={`/anime/${anime.slug}`}
              className="group block"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-100 mb-3">
                <img
                  src={anime.cover}
                  alt={anime.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  title={`${anime.title} - 樱花动漫网`}
                />
                <div className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-full">
                  {anime.rating}
                </div>
                {anime.isNew && (
                  <div className="absolute top-2 right-2 bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded-full">
                    NEW
                  </div>
                )}
              </div>
              <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                {anime.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{anime.status} &middot; {anime.episodes}集</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function CategorySection() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
            <i className="ri-apps-line text-accent-500 mr-2"></i>
            动漫分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按类型找到你喜欢的动漫</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 rounded-lg bg-background-50 hover:bg-primary-50/50 transition-all duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100/80 text-accent-600 mb-3 group-hover:bg-accent-200/80 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-sm text-foreground-800 mb-1">{cat.name}</h3>
              <p className="text-xs text-foreground-500 text-center line-clamp-2 mb-2">{cat.description}</p>
              <span className="text-xs text-secondary-600 bg-secondary-100 px-2 py-0.5 rounded-full">{cat.count}部</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function LatestSection() {
  const latest = [...animeList].sort((a, b) => b.year - a.year || b.id - a.id).slice(0, 8);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              <i className="ri-timer-line text-accent-500 mr-2"></i>
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">每日同步最新动漫资源</p>
          </div>
          <Link to="/category/rexue" className="text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap">
            全部动漫 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {latest.map((anime) => (
            <Link
              key={anime.id}
              to={`/anime/${anime.slug}`}
              className="group flex gap-3 p-3 rounded-lg bg-background-100 hover:bg-background-200/70 transition-colors"
            >
              <div className="w-16 h-20 flex-shrink-0 rounded-md overflow-hidden bg-background-200">
                <img
                  src={anime.cover}
                  alt={anime.title}
                  className="w-full h-full object-cover"
                  title={`${anime.title} - 樱花动漫网`}
                />
              </div>
              <div className="flex flex-col justify-between min-w-0">
                <div>
                  <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                    {anime.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{anime.year} &middot; {anime.season}</p>
                </div>
                <span className={`text-xs px-1.5 py-0.5 rounded-full inline-block w-fit ${anime.isNew ? 'bg-accent-100 text-accent-700' : 'bg-secondary-100 text-secondary-600'}`}>
                  {anime.status}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
            <i className="ri-question-line text-accent-500 mr-2"></i>
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于樱花动漫网的常见疑问解答</p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, i) => (
            <div key={i} className="rounded-lg bg-background-50 overflow-hidden">
              <button
                className="w-full flex items-center justify-between p-4 text-left"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-medium text-sm text-foreground-800 pr-4">{faq.q}</span>
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className={`text-foreground-500 transition-transform duration-200 ${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-4 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <main>
      <HeroSection />
      <HotAnimeSection />
      <CategorySection />
      <LatestSection />
      <FaqSection />
    </main>
  );
}